document.addEventListener("DOMContentLoaded", function () {

    const slider = document.querySelector(".featureSwiper");

    if (!slider) return;

    const desktopSlides = parseFloat(slider.dataset.desktop);
    const mobileSlides = parseFloat(slider.dataset.mobile);
    const space = parseInt(slider.dataset.space);

    new Swiper(slider, {

        speed:700,

        slidesPerView:mobileSlides,

        spaceBetween:space,

        scrollbar:{
            el: ".swiper-scrollbar",
           draggable: true,
           dragSize: "auto",
           snapOnRelease: true
        },

        navigation:{
            nextEl:".swiper-next",
            prevEl:".swiper-prev"
        },

        breakpoints:{

            768:{
                slidesPerView:desktopSlides
            }

        }

    });

});